module.exports = __webpack_public_path__ + "images/jobs/cardCm.8ee7fc8b.svg";